var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItArrowDownTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.2,12h5.6c0.6,0,1,0.5,1,1c0,0.3-0.1,0.5-0.3,0.7L12,17.3l-3.5-3.6c-0.4-0.4-0.4-1,0-1.4C8.7,12.1,8.9,12,9.2,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItArrowDownTriangle);
export default __webpack_public_path__ + "static/media/it-arrow-down-triangle.b58dd739.svg";
export { ForwardRef as ReactComponent };